import React, { useCallback, useContext, useState } from 'react'
import { Table } from 'components'
import { SchoolContext } from './SchoolContext'
import { schoolHooks, LearningGroup } from '.'
import { dataGridModel } from 'keys'

const LearningGroups = () => {
    const { setLearningGroup, learningGroup, learningGroups, learningGroupsOptions, gradeOpen, setGradeOpen, rowOpen, setRowOpen, page, setPage, pageSize, setPageSize, searchVal, setSearchVal, sorting, setSorting, setClassIndexTab } = useContext(SchoolContext)
    const learningGroupColumns = schoolHooks.useLearningGroupTableColumns()

    const [groupOpen, setGroupOpen] = useState(null)

    const updateGroup = useCallback((_, index) => {
        setLearningGroup(learningGroups.data[index])
    }, [learningGroups])

    return (
        <div className='grades'>
            <Table
                withTitle
                loading={learningGroups.isFetching}
                data={{ results: learningGroups.data || [] }}
                columns={learningGroupColumns}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                rowOpen={groupOpen}
                setRowOpen={setGroupOpen}
                visibilityModelKey={dataGridModel.learning_group}
                searchVal={searchVal}
                setSearchVal={setSearchVal}
                sorting={sorting}
                setSorting={setSorting}
                hideSorting
                hidePagination
                hideToolbar
                queryKey={learningGroupsOptions.queryKey}
                collapse={{
                    show: true,
                    columns: [],
                    showToolbar: false,
                    onCollapse: updateGroup,
                    component: () => <LearningGroup learningGroup={learningGroup} />,
                    data: [],
                    showChollapseIcon: true,
                    hideVisibilityColumns: true,
                }}
            />
        </div>
    )
}

export default LearningGroups